import * as React from 'react';
import { Field } from '@progress/kendo-react-form';
import { FormCheckbox, FormDropDownList, FormInput, FormUpload } from './forms';
import { CompanyNameValidator, TaxNumberValidator, infoValidator, requiredValidator,fileValidator2 } from '../../../login/multistep/validators';
import { useRecoilValue } from 'recoil';
import { businessType } from '../../../atom/businessType';
import { formStateAtom2 } from '../../../atom/formState2';
import { useTranslation } from 'react-i18next';

export const BasicInfo = ({ }) => {
     const {t} = useTranslation(); 
      const types = ["구매", "외주", "용역"];
     const types2 = ["설비", "전기", "정보통신", "건축", "금속", "도장/방수", "자동제어", "비계", "탱크", "에어컨냉매배관", "코킹"];
     const types3 = ["종합건설업", "전문건설업", "N/A"];

     const formState = useRecoilValue(formStateAtom2);

     const business = useRecoilValue(businessType)

     const [selectedValue, setselectedValue] = React.useState(business)
     const onChange = (event) => { setselectedValue(event.target.value) }

     const [valid, setValid] = React.useState(false);
     const [valid2, setValid2] = React.useState(false);
     const [valid3, setValid3] = React.useState(false);
     const [valid4, setValid4] = React.useState(false);


     const businessTypeValidator = (value) => {
          if (!value) {
              return t('step.businessTypeRequired'); // "업체 유형은 필수 선택 항목입니다."
          }
          if (value !== business) {
              return t('step.businessTypeMismatch'); // "선택한 업체 유형이 기존에 등록된 유형과 일치하지 않습니다."
          }
          return undefined;
      };
      


     React.useEffect(() => {
          if (formState.준법) {
               setValid3(formState.준법.length ===1 ? true : false)
          }

          if (formState.개인정보동의) {
               setValid(true)
          }

          if (formState.개인정보동의2) {
               setValid2(true)
          }
     }, [formState]);

     const defaultFiles = formState.준법 && formState.준법.map((v) => ({ name: v.name }))

     const handleValidChange = (newValid) => {
          setValid(newValid);
     };

     const handleValidChange2 = (newValid) => {
          setValid2(newValid);
     };

     const handleValidChange3 = (newValid) => {
          setValid3(newValid);
     };

     const handleValidChange4 = (newValid) => {
          setValid4(newValid);
     };


     return (
          <div className="current" data-kt-stepper-element="content">
              <div className="w-100">
                  <div className="pb-10 pb-lg-15">
                      <h2 className="fw-bold d-flex align-items-center text-dark">{t('step.basicInfoCheck')}
                          <span className="ms-1" data-bs-toggle="tooltip" title={t('step.basicInfoTooltip')}>
                              <i className="ki-duotone ki-information-5 text-gray-500 fs-6">
                                  <span className="path1"></span>
                                  <span className="path2"></span>
                                  <span className="path3"></span>
                              </i>
                          </span>
                      </h2>
                  </div>
                  <Field key={'법인명'} id={'법인명'} name={"법인명"} label={t('step.companyName')} component={FormInput} validator={CompanyNameValidator} />
                  <Field key={'사업자등록번호'} id={'사업자등록번호'} name={"사업자등록번호"} label={t('step.registrationNumber')} component={FormInput} validator={TaxNumberValidator} />
                  <Field key={'본점소재지'} id={'본점소재지'} name={"본점소재지"} label={t('step.headOfficeAddress')} component={FormInput} validator={requiredValidator} />
                  <Field key={'업체유형'} id={'업체유형'} name={"업체유형"} data={types} label={t('step.businessType')} component={FormDropDownList} validator={businessTypeValidator} onChange={onChange} />
      
                  {selectedValue === '외주' &&
                      <>
                          <Field key={'대표공종'} id={'대표공종'} name={"대표공종"} label={t('step.mainWorkType')} component={FormDropDownList} data={types2} validator={requiredValidator} />
                          <Field key={'종합전문구분'} id={'종합전문구분'} name={"종합전문구분"} label={t('step.constructionType')} component={FormDropDownList} data={types3} validator={requiredValidator} />
                      </>
                  }
      
                  <Field
                      key={'준법'} className="attach"
                      id={'준법'}
                      name={'준법'}
                      label={t('step.complianceAgreement')}
                      multiple={false}
                      hint={t('step.complianceHint')}
                      component={FormUpload} onValidChange={handleValidChange4} validator={(value) => fileValidator2(valid3)} infotype={"대표자"}
                  />
                  <a href="/download/Compliance Pledge and Compliance Questionnaire.docx" download={t('step.complianceDownloadName')}>{t('step.complianceDownloadLink')}</a>
      
                  <Field key={'개인정보동의'} id={'개인정보동의'} name={"개인정보동의"} label={t('step.personalInfoConsent')} onValidChange={handleValidChange} component={FormCheckbox}
                      validator={(value) => infoValidator(value, valid)} infotype={"대표자"} />
                  <Field key={'개인정보동의2'} id={'개인정보동의2'} name={"개인정보동의2"} label={t('step.employeeInfoConsent')} onValidChange={handleValidChange2} component={FormCheckbox}
                      validator={(value) => infoValidator(value, valid2)} infotype={"임직원"}
                  />
              </div>
          </div>
      );
      
};
